import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '@/constants/residents/residentColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

interface DesktopWelcomeCardProps {
  userName?: string;
  propertyName?: string;
}

/**
 * DesktopWelcomeCard - Welcome banner for desktop home dashboard
 */
export const DesktopWelcomeCard: React.FC<DesktopWelcomeCardProps> = ({
  userName,
  propertyName,
}) => {
  const getGreeting = (): string => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const displayName = userName || 'Resident';

  return (
    <View style={styles.card}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <RESIDENTS_SVG_COMPONENTS.HOUSE width={32} height={32} color={PRIMITIVE_COLORS.resioBlue} />
        </View>
        <View style={styles.textContainer}>
          <Text style={styles.greeting}>{getGreeting()}, {displayName}</Text>
          {propertyName && (
            <Text style={styles.propertyName}>{propertyName}</Text>
          )}
          <Text style={styles.subtitle}>Welcome to your resident portal</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: PRIMITIVE_COLORS.gray900,
    borderRadius: 16,
    padding: 24,
    borderLeftWidth: 4,
    borderLeftColor: PRIMITIVE_COLORS.resioBlue,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  iconContainer: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: PRIMITIVE_COLORS.resioBlueBg,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    flex: 1,
  },
  greeting: {
    fontSize: 24,
    fontWeight: '700',
    color: SEMANTIC_COLORS.text.primary,
    marginBottom: 4,
  },
  propertyName: {
    fontSize: 16,
    fontWeight: '500',
    color: PRIMITIVE_COLORS.resioBlueLight,
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 14,
    color: SEMANTIC_COLORS.text.tertiary,
  },
});

export default DesktopWelcomeCard;
